import React from 'react';
import Banner from '../../../../../UI/Banner/Banner';
import bannerImage from "../../../../../../assets/images/satellite/banner.png";

const OutsourcingPilarBanner = (props) => (
    <Banner
        id="outsourcing-pilar-banner"
        className="banner black pb-5 services-banner"
        title="services:outsourcingPilar.section-1.title"
        text="services:outsourcingPilar.section-1.txt"
        t={props.t}
        imageBannerRight={bannerImage}
        //imageBannerRightWebp={bannerImageWebpp} 
        timeDelay={1.55}
    />
);

export default OutsourcingPilarBanner;